<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="Look Book 商品"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/look-book',breadcrumbName:'Look Book'}
      ,{path:`/look-books/${lookBookId}`,breadcrumbName:'Look Book 商品'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!lookBookId"
         >
          <a-icon type="appstore"/>
          相关商品
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button type="primary" @click="addLookBookGoods">
          {{ $t('ADD') || '添加' }}
        </a-button>
        <a-button @click="onCancel">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <a-spin :spinning="form.loading">
      <div style="margin: 16px">
        <a-card>
          <a-table :data-source="table.data">
            <a-table-column
              title="图片">
              <template slot-scope="text, record">
                <a-avatar :src="record.goods.coverPath"/>
              </template>
            </a-table-column>
            <a-table-column
              data-index="goods.name"
              title="商品"
              width="180">
            </a-table-column>
            <a-table-column
              data-index="goods.status"
              title="状态"
              width="180">
            </a-table-column>
            <a-table-column
              data-index="date"
              :title="$t('OPERATION')||'操作'">
              <template slot-scope="text, record">
                <a-button type="link" @click="editLookBookGoods(record.id)">{{ $t('EDIT') || '编辑' }}
                </a-button>
                <a-button
                  type="link"
                  @click="deleteLookBookGoods(record.id)">{{ $t('DELETE') || '删除' }}
                </a-button>
                <a-button
                  type="link"
                  @click="upLookBookGoods(record.id)">
                  {{ $t('UP') }}</a-button>
                <a-button
                  type="link"
                  @click="downLookBookGoods(record.id)">
                  {{ $t('DOWN') }}</a-button>
              </template>
            </a-table-column>
          </a-table>
        </a-card>
      </div>
    </a-spin>
    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="form.visible">
      <look-book-goods-edit
        v-if="form.visible"
        :look-book-id="lookBookId"
        :look-book-goods-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  _queryLookBookGoodss,
  _deleteLookBookGoods,
  _upLookBookGoods,
  _downLookBookGoods,
} from '@/api/lookBookGoodsApi';
import LookBookGoodsEdit from '@/views/cms/lookBook/LookBookGoodsEdit.vue';

async function initData() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryLookBookGoodss({
    lookBookId: this.lookBookId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function onCancel() {
  this.$router.go(-1);
}

function addLookBookGoods() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editLookBookGoods(id) {
  this.form.data.id = id;
  this.form.visible = true;
}
function deleteLookBookGoods(id) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteLookBookGoods(id);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.initData();
    },
  });
}
async function upLookBookGoods(id) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upLookBookGoods(id);
      this.$message.success('上移成功');
      this.initData();
    },
  });
}

async function downLookBookGoods(id) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downLookBookGoods(id);
      this.$message.success('下移成功');
      this.initData();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.initData();
}

export default {
  name: 'LookBookGoodsList',
  components: { LookBookGoodsEdit },
  props: {
    lookBookId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    lookBookId() {
      if (this.lookBookId) {
        this.initData();
      }
    },
  },
  methods: {
    onCancel,
    initData,
    addLookBookGoods,
    editLookBookGoods,
    deleteLookBookGoods,
    closeForm,
    upLookBookGoods,
    downLookBookGoods,
  },
  data() {
    return {
      topic: {
        data: [],
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      form: {
        loading: false,
        visible: false,
        data: {
          id: '',
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
          topicId: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.lookBookId) {
      this.initData();
    }
  },
};
</script>
